import { Formik } from 'formik';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { backend } from '../axios/backend';
import { useAppContext } from '../context/AppContext';
import { parseErrorMessage } from '../utils/error-message';
import InputFormik from './formik/InputFormik';
import Button from './ui/Button';

type NewPasswordProps = {};

const NewPasswordSchema = Yup.object().shape({
  oldPassword: Yup.string().required('Bitte gib dein aktuelles Passwort an.'),
  password: Yup.string()
    .min(8, 'Bitte wähle ein Passwort mit mindestens 8 Zeichen.')
    .required('Bitte gib ein Passwort an.'),
  passwordConfirmation: Yup.string().oneOf([Yup.ref('password'), null], 'Die Passwörter stimmen nicht überein.'),
});

const NewPassword = (props: NewPasswordProps) => {
  const navigate = useNavigate();
  const { alertError, alertSuccess } = useAppContext();
  const changePasswordMutation = useMutation(
    (options: { oldPassword: string; password: string }) => backend.patch('auth/new-password', options),
    {
      onSuccess: () => {
        alertSuccess('Passwort erfolgreich geändert!');
        navigate('/');
      },
      onError: (e) => alertError(parseErrorMessage(e)),
    },
  );

  return (
    <div className="space-y-2">
      <h2 className="text-white text-lg">Passwort ändern</h2>
      <Formik
        initialValues={{
          oldPassword: '',
          password: '',
          passwordConfirmation: '',
        }}
        onSubmit={(values) => {
          changePasswordMutation.mutate(values);
        }}
        validationSchema={NewPasswordSchema}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div className="space-y-2">
              <InputFormik
                name="oldPassword"
                label="Aktuelles Passwort"
                placeholder="Dein aktuelles Passwort"
                type="password"
                autoComplete="current-password"
              />
              <InputFormik
                name="password"
                label="Passwort"
                placeholder="Dein neues Passwort"
                type="password"
                autoComplete="new-password"
              />
              <InputFormik
                name="passwordConfirmation"
                label="Nochmal dein Passwort"
                placeholder="Dein neues Password"
                type="password"
                autoComplete="new-password"
              />
              <Button type="submit" isLoading={changePasswordMutation.isLoading}>
                Passwort ändern
              </Button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default NewPassword;
